import classNames from "classnames";
import { FC } from "react";
import { ChevronLeftIcon } from "../icons/ChevronLeftIcon";
import styles from "./BackButton.module.css";

type BackButtonProps = {
  onClick: () => void;
  label?: string;
  className?: string;
};

const BackButton: FC<BackButtonProps> = ({ onClick, label, className }) => (
  <button type="button" className={classNames(styles.backButton, className)} onClick={onClick}>
    <ChevronLeftIcon />
    {label}
  </button>
);

export default BackButton;
